import initFactory from '@utils/initFactory';
import PasswordReset from './PasswordReset.vue';

export const init = initFactory(PasswordReset);
